module.exports = __webpack_public_path__ + "static/img/fuzhou.dab909a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mapPoint/mapPicture/fujian/fuzhou.png
// module id = cfsK
// module chunks = 6